module.exports = __webpack_public_path__ + "static/img/mario1x1.7134583.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/mario1x1.png
// module id = Dr8h
// module chunks = 38